import React from 'react';
import PropTypes from 'prop-types';

export function GelLabTip(props) {
  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        <h3 style={{
              fontFamily: 'Bio Sans',
              fontWeight: '700',
              fontStyle: 'normal',
              fontSize: '16px',
              lineHeight: '19.68px',
              letterSpacing: '0px',
        }}>LAB TIP: WHEN IN A LAB</h3>
        <p className={`${props.className}_message`}>
          When loading a gel, carefully position the pipette tip in the well without puncturing the gel.
        </p>
      </div>
    </div>
  );
}

GelLabTip.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Balanced Status Yes/No
   */
  balanced: PropTypes.bool,
};

GelLabTip.defaultProps = {};
